class FloatButton extends HTMLElement {
  constructor() {
    super();
    const floatButton = this.querySelector(".float-button");
    const productForm = document.querySelector(".product-info__form .product-add-button");
    if (floatButton && productForm) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            floatButton.classList.add("float-button--hidden");
          } else {
            floatButton.classList.remove("float-button--hidden");
          }
        });
      });
      observer.observe(productForm);
    }
  }
}
if (customElements.get("float-button") === void 0) {
  customElements.define("float-button", FloatButton);
}
